module.exports = __webpack_public_path__ + "static/img/shop2.11ec5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop2.png
// module id = LBPF
// module chunks = 2